module.exports = __webpack_public_path__ + "img/СТ_КЗ_2020_page-0001.c7e1fcad.jpg";